import fullyResponsive from "library/fullyResponsive"
import { css } from "styled-components"

const textStyles = {
  h1: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-size: 185px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  h2: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 145px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  h3: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 125px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  h4: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 105px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  h5: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 85px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  h6: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  h7: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 45px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  h7Alt: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 42px */
    letter-spacing: -1.68px;
  `),
  h8: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 90%;
    letter-spacing: -0.04em;
  `),
  title1: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 35px;
    line-height: 90%;
    letter-spacing: -0.03em;
  `),
  title2: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 25px;
    line-height: 100%;
    letter-spacing: -0.03em;
  `),
  title3: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: -0.03em;
  `),
  title4: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 100%;
    letter-spacing: -0.02em;
  `),
  bodyXL: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 125%;
    letter-spacing: -0.02em;
  `),
  bodyL: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 125%;
    letter-spacing: -0.02em;
  `),
  bodyR: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 125%;
    letter-spacing: -0.02em;
  `),
  bodyS: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 125%;
    letter-spacing: -0.01em;
  `),
  bodyXS: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 128%;
  `),
  bodyXXS: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 128%;
  `),
  kickerL: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: -0.01em;
    text-transform: uppercase;
  `),
  kickerR: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 100%;
    text-transform: uppercase;
  `),
  kickerS: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 100%;
    text-transform: uppercase;
  `),
  productHeader: fullyResponsive(css`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 120%;
  `),
  productBody1: fullyResponsive(css`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 120%;
  `),
  productStat1: fullyResponsive(css`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
  `),
  productPage: fullyResponsive(css`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  `),
  productPageBold: fullyResponsive(css`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 110%;
  `),
  productButton1: fullyResponsive(css`
    font-family: Inter, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 120%;
  `),
  descriptionL: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 45px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 63px */
    letter-spacing: -1.8px;
  `),
  descriptionM: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 42px */
    letter-spacing: -1.2px;
  `),
  descriptionS: fullyResponsive(css`
    font-family: "PP Mori", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 35px */
    letter-spacing: -1px;
  `),
}

// eslint rules below because we still need webkit prefix for chrome
export const strokeText = css`
  /* stylelint-disable-next-line property-no-vendor-prefix  */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  background-clip: text;
  -webkit-text-stroke-width: 0.07vw;
`

export const strokeTextTransparent = css`
  /* stylelint-disable-next-line property-no-vendor-prefix  */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  background-clip: text;
  -webkit-text-stroke-width: 0.07vw;
`

export const transparentText = css`
  /* stylelint-disable-next-line property-no-vendor-prefix  */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -moz-text-fill-color: transparent;
  background-size: 100%;
  background-clip: text;
`

export default textStyles
